// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3od9y","sendOtp":"AuthorizeToLogin_sendOtp__p0nad"};